module.exports = __webpack_public_path__ + "static/media/ladoDerecho.ef44439a.png";